import {
  DraftHeroes,
  GetDuelPickOrder,
  GetFFAPickOrder,
  getRandomInt,
  GetRandomPickOrder,
} from "./drafter";
import {
  Action,
  DraftData,
  DraftOptions,
  DraftType,
  EmptyDraftData,
  Hero,
  Player,
  ShopCard,
  Team,
  TournamentGameDetails,
} from "../types";

import { getHeroData } from "../heroes/useHeroes";
import CardData from "../cards/cards.json";

import { DraftStage, StageDraftTypes } from "./stageUtils";
import { GetFFACards } from "draft/ffa/ffaCards";
import { LoadDuelCardsPool } from "draft/duel/duelCards";

export function NewRound(
  players: Player[],
  draftOptions: DraftOptions,
  tournamnetGameDetails?: TournamentGameDetails,
  draftType?: DraftType,
) {
  if (!players) throw new Error("");

  // Cast draft type to drafttype, else default to teams
  if (!draftType) {
    draftType = DraftType.Teams;
  }

  players = cleanPlayers(players);
  players = ensurePlayersHaveAName(players);

  const draftResult = DraftHeroes(getHeroData(draftOptions.gameType), 3, false);

  let pickOrder: Action[] = [];
  switch (draftType) {
    case DraftType.FFA:
      pickOrder = GetFFAPickOrder();
      break;
    case DraftType.Duel:
      pickOrder = GetDuelPickOrder();
      AppendDraftToPlayer(players, draftResult);
      break;
    default:
      // Teams
      pickOrder = GetRandomPickOrder();
      AppendDraftToPlayer(players, draftResult);
  }

  if (draftType === DraftType.Duel) {
    players = players.slice(0, 2); // Remove player 3 and 4
    players[1].Team = Team.Red;
  }

  const currentAction = pickOrder.pop();

  // Cards
  let shopCards: ShopCard[] = [];
  switch (draftType) {
    case DraftType.FFA:
      shopCards = GetFFACards();
      break;
    case DraftType.Duel:
      shopCards = DrawCards(3, LoadDuelCardsPool());
      break;
    default:
      shopCards = DrawCards(3, LoadTeamsCards());
  }

  const stage = DraftStage(
    StageDraftTypes.ALL,
    draftOptions.gameType,
    draftOptions.stagePack,
    draftOptions.memeStageChance,
  );

  // Ensure correct order
  players.sort((p1, p2) => p1.Number - p2.Number);

  const newRound: DraftData = {
    ID: Math.random().toString(36).substring(10),
    Active: true,
    DraftType: draftType,
    GameType: draftOptions.gameType,
    ActionSequence: pickOrder,
    CurrentAction: currentAction,
    Players: players,
    ShopCards: shopCards,
    Stage: stage,
    SelectedPlayers: [],
    TournamentGameDetails: tournamnetGameDetails,
    CommonHeroes: draftType === DraftType.FFA
      ? draftResult
      : new Array<Array<Hero>>(),

    History: [],
  };

  return newRound;
}

export function LoadTeamsCards(): ShopCard[] {
  // Load all cardData into  shopcard array
  let shopCards: ShopCard[] = [];
  let uniqueIndex = 0; // Track unique index for each card instance

  Object.entries(CardData).forEach((_, index) => {
    const current = Object(CardData)[Object.keys(CardData)[index]];
    var frequency = current["Frequency"] ? current["Frequency"] : 0;

    for (var i = 0; i < frequency; i++) {
      const teamCard: ShopCard = {
        Index: uniqueIndex++,
        Name: current["Name"],
        Description: current["Description"],
        Cost: current["Cost"],
        Effects: current["Effects"],
      };
      shopCards.push(teamCard);
    }
  });
  return shopCards;
}

export function DrawCards(count: number, cardPool: ShopCard[]) {
  let drawResult = [];
  for (var i = 0; i < count; i++) {
    var pick = getRandomInt(cardPool.length);
    drawResult.push(cardPool[pick]);
    cardPool.splice(pick, 1);
  }
  return drawResult;
}

//Adding current state to its own history
export function AddToHistory(gameData: DraftData): DraftData {
  if (!gameData.History) {
    gameData.History = [];
  }

  const currentState = { ...gameData };
  currentState.History = [];

  gameData.History!.push(JSON.stringify(currentState)); // Kopierer forrige state uten
  return gameData;
}

export function PeekHistory(gameData: DraftData): DraftData {
  if (!gameData || !gameData.History) {
    throw Error("Peek History Error. History is empty");
  }

  if (gameData.History.length === 0) return EmptyDraftData();

  const prevState = gameData.History[gameData.History.length - 1];
  return JSON.parse(prevState + "");
}

export function UndoAction(gameData: DraftData): DraftData {
  const prevState = PeekHistory(gameData);
  if (prevState) {
    gameData.History!.pop();
    prevState.History = gameData.History;
    return prevState;
  }
  return gameData;
}

function cleanPlayers(playerList: Player[]) {
  playerList.forEach((p) => {
    p.BannedHeroes = [];
    p.PickedHero = undefined;
  });
  return playerList;
}

function ensurePlayersHaveAName(players: Player[]): Player[] {
  players.forEach((p) => {
    if (!p.Name) {
      p.Name = "Player " + p.Number;
    }
  });
  return players;
}
function AppendDraftToPlayer(playerList: Player[], draftResult: any) {
  for (var i = 0; i < playerList.length; i++) {
    playerList[i].Draft = draftResult[i];
  }
}

